module.exports = __webpack_public_path__ + "src/img/downloadIcon.b84b7b7a.svg";